import { Action } from '@ngrx/store';

export enum AsyncValidationsModifyActionTypes {
  ADD_ITEM = '[AsyncValidationsModify] add validator form',
  REMOVE_ITEM = '[AsyncValidationsModify] remove validator form',
  SET_PURCHASE_ORDER_VALIDATING = '[AsyncValidationsModify] set purchase order validating',
  SET_PURCHASE_ORDER_VALID = '[AsyncValidationsModify] set purchase order valid',
  SET_REPEAT_PURCHASE_ORDER_VALID = '[AsyncValidationsModify] set repeat purchase order valid',
  RESET = '[AsyncValidationsModify] reset forms',
}

export class AsyncValidationsAddItemModifyAction implements Action {
  readonly type = AsyncValidationsModifyActionTypes.ADD_ITEM;

  constructor() {}
}

export class AsyncValidationsRemoveItemModifyAction implements Action {
  readonly type = AsyncValidationsModifyActionTypes.REMOVE_ITEM;

  constructor(public payload: number) {}
}

export class PurchaseOrderValidatingModifyAction implements Action {
  readonly type = AsyncValidationsModifyActionTypes.SET_PURCHASE_ORDER_VALIDATING;

  constructor(public payload: { formId: number; purchaseOrderValidating: boolean }) {}
}

export class PurchaseOrderValidModifyAction implements Action {
  readonly type = AsyncValidationsModifyActionTypes.SET_PURCHASE_ORDER_VALID;

  constructor(public payload: { formId: number; purchaseOrderValid: boolean }) {}
}

export class RepeatPurchaseOrderValidModifyAction implements Action {
  readonly type = AsyncValidationsModifyActionTypes.SET_REPEAT_PURCHASE_ORDER_VALID;

  constructor() {}
}

export class AsyncValidationsResetModifyAction implements Action {
  readonly type = AsyncValidationsModifyActionTypes.RESET;

  constructor() {}
}

export type AsyncValidationsModifyActions =
  | AsyncValidationsAddItemModifyAction
  | AsyncValidationsRemoveItemModifyAction
  | PurchaseOrderValidatingModifyAction
  | PurchaseOrderValidModifyAction
  | RepeatPurchaseOrderValidModifyAction
  | AsyncValidationsResetModifyAction;
